<template>
	<el-button @click="$router.push({ name: 'signUp', query: { page: 1 } })" class="challenge-info" v-loading.fullscreen.lock="loading">
		<div class="top layout-row">
			<div class="title color-black-gray1">正在進行的DFC挑戰</div>
			<div class="link pointer layout-row layout-hv-center color-blue1">點選瀏覽
				<font-awesome-icon class="arrow" icon="angle-right" />
			</div>
		</div>
		<div class="items color-black-gray1 layout-row">
			<div class="item col bg-yellow2 layout-hv-center" gutter="5">
				<div class="data row" align-y="bottom" gutter="5">
					<span class="number">{{storiesStatus.not_applied}}</span>
					<span>組</span>
				</div>
				<div class="label">尚未完成報名</div>
			</div>
			<div class="item col bg-yellow2 layout-hv-center" gutter="5">
				<div class="data row" align-y="bottom" gutter="5">
					<span class="number">{{storiesStatus.applied}}</span>
					<span>組</span>
				</div>
				<div class="label">已完成報名</div>
			</div>
		</div>
	</el-button>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	data() {
		return {
			loading: true,
			storiesStatus: {}
		};
	},
	computed: {},
	methods: {
		...mapActions('story', ['getStoriesStatus']),
		linkTo(routeName) {
			this.$router.push({ name: routeName });
		}
	},
	async created() {
		this.loading = true;
		this.storiesStatus = (await this.getStoriesStatus()).data;
		this.loading = false;
	},
	mounted() { },
	components: {}
};
</script>

<style lang="scss" scoped>
.challenge-info {
	width: 360px;
	height: 165px;
	background-color: #fefcf3;
	padding: 17px;

	.top {
		justify-content: space-between;
		margin-bottom: 20px;

		.title {
			font-size: 18px;
		}

		.link {
			.arrow {
				margin-left: 7px;
			}
		}

		.link:hover {
			color: #cfe6fc;
		}
	}

	.items {
		padding-left: 2px;

		.item {
			width: 149px;
			height: 90px;
			border-radius: 5px;

			.data {
				font-size: 20px;
				font-weight: 500;

				.number {
					font-size: 32px;
				}
			}

			.label {
				font-size: 14px;
			}
		}

		.item:first-child {
			margin-right: 20px;
		}
	}
}
</style>